/**
 * social.js
 * 1. GIAO TIẾP XÃ HỘI & THUYẾT TRÌNH KHOA HỌC
 */

export const SOCIAL_POSES = {
  idle: (pose, time) => {
    // Nhịp thở nhún nhẹ nhàng, tay chân thẳng chuẩn Voxel
    pose.rootY = Math.sin(time * 2.2) * 0.012;
    pose.leftArmRotX = Math.sin(time * 2.2) * 0.035;
    pose.rightArmRotX = -Math.sin(time * 2.2) * 0.035;
    pose.leftArmRotZ = -0.06;
    pose.rightArmRotZ = 0.06;
    pose.headRotY = Math.sin(time * 0.8) * 0.08;
    pose.headRotX = Math.sin(time * 1.6) * 0.025;
  },

  wave: (pose, time) => {
    // Vẫy tay chào vui vẻ - Cánh tay phải vẫy qua lại thẳng chuẩn Voxel
    pose.rightArmRotX = -Math.PI * 0.68;
    pose.rightArmRotY = -0.15;
    pose.rightArmRotZ = 0.22 + Math.sin(time * 7.5) * 0.35;
    pose.leftArmRotX = 0.04;
    pose.leftArmRotZ = -0.08;
    pose.headRotZ = -0.1 + Math.sin(time * 3) * 0.03;
    pose.headRotY = 0.12;
    pose.rootY = Math.sin(time * 2.5) * 0.012;
  },

  greet: (pose, time) => {
    // Xin chào thân thiện (vẫy cả hai tay thẳng chuẩn Voxel)
    pose.rightArmRotX = -Math.PI * 0.65;
    pose.rightArmRotZ = 0.25 + Math.sin(time * 6.5) * 0.25;
    pose.leftArmRotX = -0.3 + Math.sin(time * 3.0) * 0.08;
    pose.leftArmRotZ = -0.25;
    pose.torsoRotY = Math.sin(time * 2.5) * 0.08;
    pose.headRotZ = -0.08;
    pose.headRotY = 0.08;
    pose.rootY = Math.sin(time * 2.5) * 0.015;
  },

  thank_you: (pose, _time, elapsed) => {
    // Cảm ơn chân thành (One-shot: Cúi nhẹ, cùi chỏ gập đặt tay phải lên ngực trái)
    const t = Math.min(elapsed, 2.0);
    let factor = 0;
    if (t < 0.6) {
      factor = t / 0.6; // Đang cúi
    } else if (t < 1.4) {
      factor = 1.0; // Giữ nguyên tư thế cảm ơn
    } else {
      factor = Math.max(0, 1.0 - (t - 1.4) / 0.6); // Đứng thẳng trở lại
    }

    pose.torsoRotX = factor * 0.24;
    pose.headRotX = factor * 0.2;
    // Tay phải nâng gập đặt lên ngực trái
    pose.rightArmRotX = -factor * 0.55;
    pose.rightArmRotY = -factor * 0.35;
    pose.rightArmRotZ = factor * 0.25;
    pose.rightForearmRotX = -factor * 1.35;
    pose.rightForearmRotY = -factor * 0.2;
    // Tay trái khép nhẹ sát đùi
    pose.leftArmRotX = factor * 0.1;
    pose.leftArmRotZ = -0.06;
    pose.leftForearmRotX = -factor * 0.1;
    pose.rootY = -factor * 0.02;
  },

  apologize: (pose, _time, elapsed) => {
    // Xin lỗi hối lỗi (One-shot: Cúi gập người, hai khuỷu tay gập chắp tay trước bụng)
    const t = Math.min(elapsed, 2.2);
    let factor = 0;
    if (t < 0.7) {
      factor = t / 0.7;
    } else if (t < 1.5) {
      factor = 1.0; // Giữ tư thế hối lỗi
    } else {
      factor = Math.max(0, 1.0 - (t - 1.5) / 0.7);
    }

    pose.torsoRotX = factor * 0.42;
    pose.headRotX = factor * 0.35;
    // Hai tay chắp trước bụng hối lỗi
    pose.leftArmRotX = -factor * 0.4;
    pose.leftArmRotY = factor * 0.3;
    pose.leftArmRotZ = factor * 0.15;
    pose.leftForearmRotX = -factor * 0.95;

    pose.rightArmRotX = -factor * 0.4;
    pose.rightArmRotY = -factor * 0.3;
    pose.rightArmRotZ = -factor * 0.15;
    pose.rightForearmRotX = -factor * 0.95;

    // Khụy nhẹ gối
    pose.leftCalfRotX = factor * 0.25;
    pose.rightCalfRotX = factor * 0.25;
    pose.rootY = -factor * 0.04;
  },

  bow: (pose, _time, elapsed) => {
    // Cúi chào cung kính chuẩn mực Á Đông (One-shot: Gập eo, tay chân thẳng trang nghiêm)
    const t = Math.min(elapsed, 2.0);
    let factor = 0;
    if (t < 0.6) {
      factor = t / 0.6;
    } else if (t < 1.4) {
      factor = 1.0;
    } else {
      factor = Math.max(0, 1.0 - (t - 1.4) / 0.6);
    }

    pose.torsoRotX = factor * 0.65;
    pose.headRotX = factor * 0.15;
    pose.leftArmRotX = factor * 0.2;
    pose.rightArmRotX = factor * 0.2;
    pose.leftArmRotZ = -0.05;
    pose.rightArmRotZ = 0.05;
    pose.rootY = -factor * 0.025;
  },

  present: (pose, time) => {
    // Thuyết trình khoa học (Loop: Tay phải gập mở chỉ lên bảng, tay trái diễn thuyết)
    const gestureCycle = time * 2.8;
    pose.rightArmRotX = -0.75 + Math.sin(gestureCycle) * 0.12;
    pose.rightArmRotY = -0.3;
    pose.rightArmRotZ = 0.32 + Math.cos(gestureCycle * 0.7) * 0.1;
    pose.rightForearmRotX = -0.55 + Math.sin(gestureCycle * 0.8) * 0.15;

    pose.leftArmRotX = -0.3 + Math.sin(gestureCycle * 0.6) * 0.08;
    pose.leftArmRotZ = -0.15;
    pose.leftForearmRotX = -0.5 + Math.sin(gestureCycle * 0.6) * 0.1;

    pose.torsoRotY = Math.sin(gestureCycle * 0.5) * 0.1;
    pose.headRotX = 0.06;
    pose.headRotY = Math.cos(gestureCycle * 0.5) * 0.12;
    pose.rootY = Math.sin(time * 2.0) * 0.01;
  },

  explain: (pose, time) => {
    // Giảng giải bài học: Cả 2 tay co gập khuỷu tay cử động sinh động
    const gestureCycle = time * 3.0;
    pose.rightArmRotX = -0.5 + Math.sin(gestureCycle) * 0.15;
    pose.rightArmRotY = -0.2 + Math.cos(gestureCycle * 0.7) * 0.12;
    pose.rightArmRotZ = 0.2;
    pose.rightForearmRotX = -0.75 + Math.sin(gestureCycle * 0.7) * 0.2;

    pose.leftArmRotX = -0.3 + Math.sin(gestureCycle * 0.6) * 0.08;
    pose.leftArmRotZ = -0.1;
    pose.leftForearmRotX = -0.6 + Math.cos(gestureCycle * 0.6) * 0.15;

    pose.headRotX = 0.06 + Math.sin(gestureCycle) * 0.08;
    pose.headRotY = Math.cos(gestureCycle * 0.5) * 0.1;
    pose.rootY = Math.sin(time * 2.0) * 0.01;
  },

  think: (pose, time) => {
    // Suy nghĩ kinh điển: Tay trái khoanh bụng đỡ khuỷu tay phải, tay phải gập khuỷu chống cằm
    pose.leftArmRotX = -0.35;
    pose.leftArmRotY = 0.35;
    pose.leftArmRotZ = -0.15;
    pose.leftForearmRotX = -1.15; // Tay trái ôm bụng đỡ khuỷu

    pose.rightArmRotX = -0.45;
    pose.rightArmRotY = -0.25;
    pose.rightArmRotZ = 0.3;
    pose.rightForearmRotX = -1.65; // Gập khuỷu tay phải đưa bàn tay lên cằm!

    pose.torsoRotX = 0.08;
    pose.torsoRotZ = 0.06;
    pose.headRotX = -0.22; // Ngước đầu lên trời
    pose.headRotZ = 0.16 + Math.sin(time * 1.5) * 0.02; // Nghiêng nhẹ đầu
    pose.headRotY = 0.12;
    pose.leftLegRotX = 0.04;
    pose.rightLegRotX = -0.06;
  },

  cheer: (pose, time) => {
    // Tán dương, reo mừng: Hai tay giơ cao vỗ tay, chân thẳng nhún nhảy theo nhịp
    const jumpCycle = time * 7.0;
    const clapCycle = time * 9.0;
    pose.leftArmRotX = -Math.PI * 0.75;
    pose.rightArmRotX = -Math.PI * 0.75;

    pose.leftArmRotZ = -0.25 - Math.sin(clapCycle) * 0.12;
    pose.rightArmRotZ = 0.25 + Math.sin(clapCycle) * 0.12;
    pose.leftArmRotY = 0.12;
    pose.rightArmRotY = -0.12;

    pose.rootY = Math.abs(Math.sin(jumpCycle)) * 0.09;
    pose.headRotX = -0.12 + Math.sin(clapCycle) * 0.06;
  }
};
